<template>
	<div class="request-card-wrapper">
		<div v-if="customSizeWithPrice !== undefined">
			<div class="red-font" v-for="sizeAndprice in customSizeWithPrice">
				{{ formatPrice(calcTaxedPriceCents(sizeAndprice.price, taxRate)) }} ({{ sizeAndprice.size_name }})
			</div>
		</div>
		<transition name="stretch" mode="out-in">
			<div v-if="showAddBtns" key="open">
				<div class="playlist-request-btn-list">
					<div class="request-close-wrapper">
						<div class="request-close-btn" @click="addButtonClicked()">
							<span>&#215;</span>
						</div>
					</div>
					<div v-for="playlist in playlists" :style="{ 'background-color': backgroundColor, 'position': 'relative' }">
						<button @mouseover="isHovering = true" @mouseout="isHovering = false" @click="addOrRemoveCoffee(playlist.id)"
            :class="[playlist.name.length > 25 ? { hovering: isHovering } : '', isAdded(playlist.id) ? 'black-btn' : 'transparent-btn']"  class="btn-lg productBtn playlist-request-btn">
							<span class="nb-count"> 
								<span class="nb-count-inn">{{numberRequest(playlist)}}</span> 
								<span class="nb-icon"><i class="fas fa-user request-coffee-icon"></i></span>
							</span>				
							<span class="nb-content">
								<span class="cl-red"><strong>{{ getPlaylistName(playlist) }}</strong></span>
								<br>{{ getrequestdetail(playlist) }}
							</span>
						</button>
						<div v-if="playlist.name.length > 22" class="cstmTooltip-container">
              				<div class="inner">
                				<p>{{ getPlaylistName(playlist) }}</p>
              				</div>
            			</div>
					</div>
				</div>
				<div class="btn-placeholder"></div>
			</div>
			<div v-else key="close"> 
				<button class="btn-lg request-btn" @click="addButtonClicked()"
					v-bind:class="addedPlaylistIds.length ? 'black-btn' : 'transparent-btn'">
					<span v-if="addedPlaylistIds.length">Added</span>
					<span v-else>Add to Brew Queue</span>
				</button>
			</div>
		</transition>
			<p><strong>{{ numRequests }}</strong> team members have requested this.</p>
	</div>
</template>

<script>
import CoffeeMixin from '../../mixins/coffee-mixin';
import CommonMixin from '../../mixins/common-mixin';

export default {
	props: {
		coffee: Object,
		playlists: Array,
		addedPlaylistIdsProp: Array,
		backgroundColor: String,
		numRequests: Number,
		requests: Array,
		requestdetails: Array,
		products: Array,
		productSizes: Array,
		taxRate: Number,
		cId: Number
		
	},
	data: function () {

		return {
			showAddBtns: false,
			addedPlaylistIds: this.addedPlaylistIdsProp,
      		isHovering: false,
			customSizeWithPrice: undefined
		}	
	},
	computed: {
		customSize12Oz() {
			return this.coffee.custom_size_12oz || '12oz';
		},
		customSize5lb() {
			return this.coffee.custom_size_5lb || '5lb';
		},
		taxedPrice() {
			return this.calcTaxedPriceCents(this.coffee.price_cents, this.taxRate);
		},
		taxedPrice5lb() {
			return this.calcTaxedPriceCents(this.coffee.price_5lb_cents, this.taxRate);
		},	
	},
	methods: {
		getPlaylistName(playlist) {
			// Add location name if there is the same playlist name
			// if (this.playlists.find(p => p.name === playlist.name && p.id === playlist.id)) {
			 return `${playlist.location.name}: ${playlist.name}`;
			// }
		},
		getrequestdetail(playlist) {
			var dateString = playlist.requests.filter(r => r.product_id === this.cId).map((d) => d.created_at)
				dateString = (dateString.length > 1) ? dateString.slice(-1)[0] : dateString ;
			if (dateString.length >= 1 ){
				let date = new Date(dateString);
        		const options = { year: 'numeric', month: 'short', day: 'numeric' };
        		dateString = date.toLocaleDateString("en-US", options);
        		return  "Last Request "+dateString;
			}
			else {
        		return '';
   				} 
		},
		numberRequest(playlist){
			let cid = this.cId;
			if (this.requestdetails != undefined){
				var count = this.requestdetails.filter((r) => r.workplace_playlist_id === playlist.id).map((m) => {return (cid == m.product_id) ? m.id : null; });
					count = count.filter((p) => { return (p != null); });
				return count.length;
			}
			else{
				var count = this.requests.filter((r) => r.workplace_playlist_id === playlist.id).map((m) => {return (cid == m.product_id) ? m.id : null; });
					count = count.filter((p) => { return (p != null); });
				return count.length;
			}
		},
		
		addButtonClicked() {
			if (this.playlists.length === 1) {
				this.addOrRemoveCoffee(this.playlists[0].id);
				return;
			}
			this.showAddBtns = !this.showAddBtns;
		},
		isAdded(playlistId) {
			return this.addedPlaylistIds && this.addedPlaylistIds.includes(playlistId);
		},
		addOrRemoveCoffee(playlistId) {
			this.isAdded(playlistId) ? this.removeCoffeeFromPlaylist(playlistId) : this.addCoffeeToPlaylist(playlistId);
		},
		addCoffeeToPlaylist(playlistId) {
			this.addedPlaylistIds.push(playlistId);
			this.$playlistsApi.post('push_product', { playlistId: playlistId, productId: this.coffee.id })
		},
		removeCoffeeFromPlaylist(playlistId) {
			this.addedPlaylistIds = this.addedPlaylistIds.filter(id => id !== playlistId);
			this.$playlistsApi.delete('remove_product', { params: { playlistId: playlistId, productId: this.coffee.id } });
		},
	},
	mounted (){
		let customSizes = this.productSizes.filter(r => r.product_id === this.coffee.id);
		this.customSizeWithPrice = customSizes.sort(function(a, b){return  parseFloat(a.size_name) - parseFloat(b.size_name)});
	},
	mixins: [
		CommonMixin,
		CoffeeMixin
	]
}
</script>

<style scoped>
	.request-card-wrapper {
		min-height: 100px;
	}

	.request-close-wrapper {
		width: 100%;
		height: 20px;
	}

	.playlist-request-btn-list {
		position: absolute;
		bottom: 0;
		width: 100%;
		margin-bottom: 4rem;
		max-height: 1000px;
		z-index: 9;
		background: #fff;
		max-width: 270px;
	}
	.request-close-btn {
		float: right;
		width: 30px;
		height: 30px;
		line-height: 30px;
		border-radius: 50%;
		background-color: #1F323B;
		text-align: center;
		font-size: 22px;
		color: white;
		cursor: pointer;
		position: relative;
		z-index: 1;
		margin-bottom: 5px;
	}

	.btn-placeholder {
		height: 84px;
	}

	.playlist-request-btn {
		margin: 0.5rem 0;
		font-weight: normal;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
		font-size: 16px !important;
	}

	.request-btn {
		margin: 1.5rem 0;
	}

	/* Tooltip Starts */
	.cstmTooltip-container {
		background: #142127;
		color: #fff;
		font-size: 13px;
		padding: 8px;
		border-radius: 5px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 63px;
		margin: 0 auto;
		z-index: 99;
		border: none;
		opacity: 0;
		visibility: hidden;
		transition: 300ms ease-in;
		-webkit-transition: 300ms ease-in;
		-moz-transition: 300ms ease-in;
		-ms-transition: 300ms ease-in;
		transform: translateY(-10px);
	}

	.cstmTooltip-container:before {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
		border-left: 6px solid transparent;
		border-right: 6px solid transparent;
		border-top: 7px solid #142127;
		bottom: -7px;
	}

	.playlist-request-btn:hover~.cstmTooltip-container {
		opacity: 1;
		visibility: visible;
		transform: translateY(0px);
	}
	
	.productBtn{
		display: flex;
		align-items: center;
		padding: 0 15px;
		/* flex-wrap: wrap; */
	}

	.nb-count {
		flex: 0 0 30px;
		max-width: 30px;
		display: inline-flex;
		flex-direction: column;
		align-items: flex-end;
	}
	.nb-count-inn{
		width: 25px;
		height: 16px;
		background: #1F323B;
		position: relative;
		border-radius: 40px;
		color: white;
		text-align: center;
		font-size: 12px;
		display: inline-block;
	}
	.nb-count-inn:before{
		content: "";
		position: absolute;
		left: 0;
		top: 15px;
		width: 0;
		height: 0;
		border-left: 10px solid transparent;
		border-right: 10px solid #1F323B;
		border-bottom: 6px solid transparent;
	}
	.nb-content{
		flex-basis: calc(92% - 30px);
		max-width: calc(95% - 30px);
		overflow: hidden;
		text-overflow: ellipsis;
		padding-left: 22px;
		text-align: left;
		font-size: 15px;
	}

	.nb-icon{
		position: relative;
		right: -10px;
	}
	.cl-red {
		color: #e15f60;
	}

	.black-btn .nb-count-inn{
		background: #fff;
		color: #1f323b;
	}

	.black-btn .nb-count-inn:before{
		border-right-color: #fff;
	}

</style>
